export default "__VITE_ASSET__1de4ceb9__"